export default {"src":"/_next/static/media/img-payment-completed.2359d134.svg","height":135,"width":108,"blurWidth":0,"blurHeight":0};